import { Gavel, QrCode, Building2, LineChart, SearchCheck, Share2 } from "lucide-react";

const Semaforo = () => (
  <div className="mt-8 space-y-2.5">
    {[["Appartamento Via Roma 12", "Regolare", "bg-[#16a34a]"], ["Bilocale Corso Italia 4", "In scadenza", "bg-amber-500"], ["Monolocale Via Po 33", "In ritardo", "bg-[#dc2626]"]].map(([n, s, c]) => (
      <div key={n} className="flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm">
        <span className="font-medium text-[#0f172a]">{n}</span>
        <span className="inline-flex items-center gap-2 text-xs font-semibold text-slate-600"><span className={`h-2.5 w-2.5 rounded-full ${c}`} />{s}</span>
      </div>
    ))}
  </div>
);

const steps = [
  { icon: Building2, title: "Registra immobili e inquilini", text: "Inserisci i tuoi immobili, i canoni mensili e il giorno di scadenza." },
  { icon: LineChart, title: "Monitora i canoni", text: "Segna i pagamenti ricevuti: lo stato si aggiorna in automatico." },
  { icon: SearchCheck, title: "Verifica i candidati", text: "Cerca nel database delle convalide di sfratto verificate." },
  { icon: Share2, title: "Condividi il passaporto", text: "Con il consenso dell'inquilino, condividi il suo storico puntuale." },
];

export const Features = () => (
  <section id="come-funziona" className="border-t border-slate-200 bg-white py-16 md:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <span className="eyebrow-label">Come Funziona</span>
      <h2 className="mt-4 max-w-2xl text-2xl font-bold tracking-tight text-[#0f172a] sm:text-3xl lg:text-4xl">Tre strumenti, un solo obiettivo: locazioni senza sorprese.</h2>
      <div className="mt-12 grid gap-6 md:grid-cols-3 lg:gap-8">
        <article data-testid="feature-card-semaforo" className="surface p-6 hover:border-[#2563eb] sm:p-8 md:col-span-2 md:row-span-2" style={{ transition: "border-color 200ms" }}>
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#1e3a8a] text-white"><span className="flex gap-1"><i className="h-1.5 w-1.5 rounded-full bg-green-400" /><i className="h-1.5 w-1.5 rounded-full bg-amber-400" /><i className="h-1.5 w-1.5 rounded-full bg-red-400" /></span></span>
          <h3 className="mt-6 text-xl font-semibold text-[#1e3a8a] sm:text-2xl">Monitoraggio a Semaforo</h3>
          <p className="mt-3 max-w-lg text-[#64748b]">Gestisci i canoni mensili dei tuoi immobili. Visualizza a colpo d'occhio chi è regolare, chi è in scadenza e chi è in ritardo.</p>
          <Semaforo />
        </article>
        <article data-testid="feature-card-atti-giudiziari" className="surface p-6 hover:border-[#2563eb] sm:p-8" style={{ transition: "border-color 200ms" }}>
          <Gavel className="h-8 w-8 text-[#1e3a8a]" />
          <h3 className="mt-5 text-xl font-semibold text-[#1e3a8a]">Solo Atti Giudiziari</h3>
          <p className="mt-3 text-sm text-[#64748b]">Zero rischio di diffamazione: le segnalazioni di morosità grave vengono accettate solo con PDF allegato dello sfratto convalidato dal giudice.</p>
        </article>
        <article data-testid="feature-card-passaporto" className="surface p-6 hover:border-[#2563eb] sm:p-8" style={{ transition: "border-color 200ms" }}>
          <QrCode className="h-8 w-8 text-[#1e3a8a]" />
          <h3 className="mt-5 text-xl font-semibold text-[#1e3a8a]">Passaporto dell'Inquilino</h3>
          <p className="mt-3 text-sm text-[#64748b]">Gli inquilini virtuosi possono condividere il proprio storico di pagamenti regolari per trovare casa più velocemente e con più fiducia.</p>
        </article>
      </div>
      <ol className="mt-16 grid gap-8 border-t border-slate-200 pt-12 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map(({ icon: Icon, title, text }, i) => (
          <li key={title}>
            <div className="flex items-center gap-3">
              <span className="font-mono text-xs font-medium text-[#2563eb]">0{i + 1}</span>
              <Icon className="h-5 w-5 text-[#1e3a8a]" />
            </div>
            <h4 className="mt-3 font-semibold text-[#0f172a]">{title}</h4>
            <p className="mt-1.5 text-sm text-[#64748b]">{text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
